<app-legal-document documentType="privacy" mode="page"></app-legal-document>
